module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/tryout-members",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _c('span', [_vm._v("Tryout Members")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6664fc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tryout_members/components/Navigation.vue
// module id = 2246
// module chunks = 1